/**
 * RandomJungle Part
 * Randomizes jungle terrain appearance at runtime
 */

import { Part } from '../Part';
import { Events } from '../types';
import { Render } from './Render';
import { random } from '@/utils/Random';

/**
 * RandomJungle part
 * On object creation, randomizes the Render part's appearance
 * - 10% bright green, 90% dark green foreground
 * - Detail color always bright green
 * - Random tile from 9 variants (tile_jungle{1-3}{a-c}.png)
 */
export class RandomJungle extends Part {
  readonly name = 'RandomJungle';

  onEvent(event: string, _data?: unknown): boolean {
    if (event === Events.OBJECT_CREATED) {
      this.setupJungle();
    }
    return true;
  }

  private setupJungle(): void {
    const render = this.parent?.getPart<Render>('Render');
    if (!render) return;

    // 10% bright green, 90% dark green
    const isBright = random.nextInt(10) === 0;
    render.colorString = isBright ? '&G' : '&g';
    render.detailColor = 'G';

    // Random tile from 9 variants
    const tileNum = random.nextInt(3) + 1;
    const tileSuffix = random.choice(['a', 'b', 'c']);
    render.tile = `terrain/tile_jungle${tileNum}${tileSuffix}.png`;
  }
}

/**
 * Factory for creating RandomJungle parts
 */
export function createRandomJungle(_params: Record<string, unknown>): RandomJungle {
  return new RandomJungle();
}
